<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          v-model="address"
          outlined
          :placeholder="$t('Profile.Address')"
          name="address"
          type="text"
          :rules="rules.cryptoAddress"
          @keyup.enter="addFunds"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          :loading="loading"
          color="primary"
          @click="addFunds"
        >
          {{ $t('faucet.AddFunds') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SmartRepository from "@/repositories/SmartRepository";
import ApiRepository from "@/repositories/ApiRepository";

export default {
    name: "Faucet",
    data () {
        SmartRepository.getMyAddress().then((address) => {
            this.address = address;
        });
        return {
            rules: {
                cryptoAddress: [val => (SmartRepository.isAddress(val) || val === '') || this.$t('Error.This field is required')],
            },
            loading: false,
            address: ''
        };
    },
    methods: {
        addFunds () {
            this.loading = true;
            ApiRepository.addFunds(this.address).then(() => {
                this.$root.$emit('show-snackbar', {message: this.$t('Contact added successfully!'), color: "success"});
            }).catch((e) => {
                console.log(JSON.stringify(e.response.status))
                if (e.response.status === 402) {
                    this.$root.$emit('show-snackbar', {message: this.$t(e.response.data.error), color: 'error'});
                } else {
                    this.$root.$emit('show-snackbar', {message: e, color: 'error'});
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    }
};
</script>

<style scoped>

</style>
